import { create } from "zustand";
import axiosInstance from "../services/axiosInstance";
import socketService from "../services/socketService";
import { notifications as mantineNotifications } from "@mantine/notifications";

const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount: 0,
  loading: false,

  fetchNotifications: async () => {
    set({ loading: true });
    try {
      const response = await axiosInstance.get("/notifications");
      if (response.data.success) {
        const notifications = response.data.notifications;
        const unreadCount = notifications.filter((n) => !n.isRead).length;
        set({ notifications, unreadCount, loading: false });
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      set({ loading: false });
    }
  },

  addNotification: (notification) => {
    set((state) => {
      const newNotifications = [notification, ...state.notifications].slice(
        0,
        50,
      );
      return {
        notifications: newNotifications,
        unreadCount: state.unreadCount + 1,
      };
    });

    // Show Mantine notification
    mantineNotifications.show({
      title: notification.title,
      message: notification.message,
      color:
        notification.type === "success"
          ? "teal"
          : notification.type === "error"
            ? "red"
            : "brand",
      autoClose: 10000,
    });
  },

  markAsRead: async (id) => {
    try {
      await axiosInstance.put(`/notifications/${id}/read`);
      set((state) => ({
        notifications: state.notifications.map((n) =>
          n.id === id ? { ...n, isRead: true } : n,
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      }));
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  },

  markAllAsRead: async () => {
    try {
      await axiosInstance.put("/notifications/read-all");
      set((state) => ({
        notifications: state.notifications.map((n) => ({ ...n, isRead: true })),
        unreadCount: 0,
      }));
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    }
  },
}));

export default useNotificationStore;
